/**
 * The Trust & Safety Overview (WALLIYO-0132), built to the approved design.
 *
 * Ordered by how serious it is rather than when it arrived, and each report
 * named by what it says rather than by its number — a reference tells nobody
 * whether to open it now.
 *
 * The verification queue and the legal holds sit beside it because neither is a
 * decision: one is a promise to pros waiting to be findable, the other is
 * something somebody must know before they answer a data request.
 */

import type { TrustOverview as Data } from "@wallyo/contracts/console/overview";

import { t, tCount } from "../../i18n";
import { formatNumber } from "../../i18n/format";
import { Figures } from "./OverviewScreen";
import { QueueRows, Tallies } from "./QueueRows";

export function TrustOverviewView({ data }: { data: Data }) {
  return (
    <>
      <Figures figures={data.figures} />

      <div className="ov-split">
        <section className="card">
          <div className="ov-card-head">
            <h2>{t("overview.trust.needsDecision")}</h2>
            <span className="foot">{t("overview.trust.mostSeriousFirst")}</span>
          </div>
          <QueueRows rows={data.decisions} area="trust" empty={t("overview.trust.nothingUrgentHere")} />
        </section>

        <div className="ov-side">
          <section className="card">
            <h2>{t("overview.trust.verificationQueue")}</h2>
            <Tallies tallies={data.queue} area="trust" />
            <p className="foot">{t("overview.trust.whyVerify")}</p>
          </section>

          {data.legalHolds > 0 ? (
            <section className="card ov-callout hold">
              <h2>{t("overview.trust.legalHolds")}</h2>
              <p className="foot">
                {tCount("overview.trust.legalHoldsWhy", data.legalHolds, {
                  count: formatNumber(data.legalHolds),
                })}
              </p>
            </section>
          ) : null}
        </div>
      </div>
    </>
  );
}
